import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function BasicCard({ name, description, docUrl, githubUrl }) {
  return (
    <Card sx={{height: "100%", display: "flex", flexDirection: "column"}}>
      <CardContent>
        <Typography variant="h5" component="div" color="#4615b2">
          {name}
        </Typography>
        <Typography variant="body2" color="#000000">
          {description}
        </Typography>
      </CardContent>
      <CardActions sx={{mt:"auto"}}>
        <Button size="small">
          <Link to={docUrl}>Docs</Link>
        </Button>
        <Button size="small">
          <Link to={githubUrl}>Github</Link>
        </Button>
      </CardActions>
    </Card>
  );
}
